<template>
  <div>
    <validation-observer ref="directObserver" method="post">
      <table class="table">
        <tr>
          <th>
            名称
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              v-slot="{ errors }"
              rules="required|max:25|char"
              name="MEI"
            >
              <b-form-input
                ref="MEI"
                maxlength="25"
                v-model="other.MEI"
                :state="errors.length ? false : null"
                placeholder="株式会社ロジコ"
                trim
                @blur="other.MEI = replaceChar(other.MEI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>郵便番号</th>
          <td>
            <div class="row">
              <div class="col-4">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:3"
                  name="YUBIN1"
                >
                  <b-form-input
                    ref="YUBIN1"
                    type="tel"
                    maxlength="3"
                    v-model="other.YUBIN1"
                    :state="errors.length ? false : null"
                    placeholder="160"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <span class="py-smー2">-</span>
              <div class="col-4">
                <validation-provider
                  v-slot="{ errors }"
                  rules="numeric|digits:4"
                  name="YUBIN2"
                >
                  <b-form-input
                    ref="YUBIN2"
                    type="tel"
                    maxlength="4"
                    v-model="other.YUBIN2"
                    :state="errors.length ? false : null"
                    placeholder="0023"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <button
                type="button"
                class="btn btn-success"
                @click="searchAddress"
                style="height: 40px"
              >
                検索
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            都道府県&ensp;
            <br v-if="isPC" />
            市区町村
            <span class="must">必須</span>
          </th>
          <td>
            <div class="row">
              <div class="col-5">
                <validation-provider
                  name="TODO_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="TODO_CD"
                    v-model="other.TODO_CD"
                    :state="errors.length ? false : null"
                    :options="prefList"
                    trim
                    @change="changePref"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <div class="col-7">
                <validation-provider
                  name="SHIKU_CD"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <b-form-select
                    ref="SHIKU_CD"
                    :disabled="!cityList.length"
                    v-model="other.SHIKU_CD"
                    :state="errors.length ? false : null"
                    :options="cityList"
                    trim
                    @change="changeCity"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>
            番地建物名
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="BANCHI"
              v-slot="{ errors }"
              rules="required|max:25|char"
            >
              <b-form-input
                ref="BANCHI"
                maxlength="25"
                v-model="other.BANCHI"
                :state="errors.length ? false : null"
                placeholder="西新宿7－4－3 升本ビル4F"
                trim
                @blur="other.BANCHI = replaceChar(other.BANCHI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            TEL
            <span class="must">必須</span>
          </th>
          <td>
            <validation-provider v-slot="{ errors }" rules="required|tel">
              <b-form-input
                maxlength="17"
                v-model="other.TEL"
                :state="errors.length ? false : null"
                placeholder="03-5937-4777"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            担当者名
            <span v-if="isLease" class="must">必須</span>
          </th>
          <td>
            <validation-provider
              name="TANTO_MEI"
              v-slot="{ errors }"
              :rules="`${isLease ? 'required|' : ''}max:20|char`"
            >
              <b-form-input
                ref="TANTO_MEI"
                maxlength="20"
                v-model="other.TANTO_MEI"
                :state="errors.length ? false : null"
                placeholder="山田太郎"
                trim
                @blur="other.TANTO_MEI = replaceChar(other.TANTO_MEI)"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            担当者
            <br v-if="isPC" />
            TEL
          </th>
          <td>
            <validation-provider v-slot="{ errors }" rules="max:17|tel">
              <b-form-input
                maxlength="17"
                v-model="other.TANTO_TEL"
                :state="errors.length ? false : null"
                placeholder="090-1234-5678"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>種別</th>
          <td>
            <validation-provider v-slot="{ errors }">
              <b-form-select
                v-model="other.YUSO_KBN"
                :state="errors.length ? false : null"
                :options="yusoKbnList"
                trim
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>
            定休日
            <span v-if="isRequiredTeikyubi" class="must">必須</span>
          </th>
          <td>
            <validation-provider
              v-slot="{ errors }"
              :rules="{ required: isRequiredTeikyubi }"
            >
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-1`"
                  v-model="other.TEIKYU_BI"
                  value="月"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-1`">
                  月
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-2`"
                  v-model="other.TEIKYU_BI"
                  value="火"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-2`">
                  火
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-3`"
                  v-model="other.TEIKYU_BI"
                  value="水"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-3`">
                  水
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-4`"
                  v-model="other.TEIKYU_BI"
                  value="木"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-4`">
                  木
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-5`"
                  v-model="other.TEIKYU_BI"
                  value="金"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-5`">
                  金
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-6`"
                  v-model="other.TEIKYU_BI"
                  value="土"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-6`">
                  土
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-7`"
                  v-model="other.TEIKYU_BI"
                  value="日"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-7`">
                  日
                </label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  :state="errors.length ? false : null"
                  class="form-check-input"
                  type="checkbox"
                  :id="`${prefixCd}-teikyubi-8`"
                  v-model="other.TEIKYU_BI"
                  value="祝"
                />
                <label class="form-check-label" :for="`${prefixCd}-teikyubi-8`">
                  祝
                </label>
              </div>
              <div
                v-if="errors.length"
                class="invalid-feedback"
                style="display: block"
              >
                <span class="border-red">{{ errors[0] }}</span>
              </div>
            </validation-provider>
          </td>
        </tr>
        <tr>
          <th>営業時間</th>
          <td>
            <div class="row">
              <div class="col-5">
                <select
                  class="form-control form-input"
                  v-model="other.EIGYO_KAISI_JIKAN"
                >
                  <option value="">未選択</option>
                  <option v-for="jikan in time" :value="jikan" :key="jikan">
                    {{ jikan }}
                  </option>
                </select>
              </div>
              <span class="py-smー2 px-0">~</span>
              <div class="col-5">
                <select
                  class="form-control form-input"
                  v-model="other.EIGYO_SYURYO_JIKAN"
                >
                  <option value="">未選択</option>
                  <option v-for="jikan in time" :value="jikan" :key="jikan">
                    {{ jikan }}
                  </option>
                </select>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </validation-observer>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import _ from 'lodash'
import Mixin from '../mixin/Mixin'

const HIKINO_SAKI = {
  AA_KAISAI_BI: null,
  YUBIN1: null,
  YUBIN2: null,
  TODO_CD: null,
  TODO_MEI: null,
  SHIKU_CD: '',
  SHIKU_MEI: null,
  BANCHI: null,
  MEI: null,
  TEL: null,
  TANTO_MEI: null,
  TANTO_TEL: null,
  YUSO_KBN: '',
  HCB_ZOKUSEI_CD: null,
  LANDMARK_KBN: null,
  TEIKYU_BI: [],
  EIGYO_KAISI_JIKAN: '',
  EIGYO_SYURYO_JIKAN: '',
  TOROKUBAYO_KO_ID: null,
  HANNYUSYUTU_JIKAN: null,
  AA_CD: null,
  AA_ID: null,
}

const DATA_KBN = 'DIRECT'
export default {
  name: 'DirectEdit',
  mixins: [Mixin],

  props: {
    /** 検索条件 */
    _searchCond: {
      type: Object,
      default: null,
    },

    /** 検索実行フラグ */
    isSearch: {
      type: Boolean,
      default: false,
    },

    /** バリデーション実行フラグ */
    isValid: {
      type: Boolean,
      default: false,
    },

    /** 名変フラグ */
    isMeihen: {
      type: Number,
      default: 0,
    },

    /** 引取先フラグ */
    isHikitori: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    /** 直接入力データ */
    other: _.cloneDeep(HIKINO_SAKI),

    isLoading: false,

    /** 市区町村リスト */
    cityList: [],

    /** 検索条件 */
    searchCond: {
      TODO_CD: null,
      SHIKU_CD: null,
    },

    /** ラジオ、チェックボックスに利用するIDのprefix */
    prefixCd: Math.random().toString(32).substring(2),
  }),

  methods: {
    /** バリデーション実行 */
    validate() {
      this.$v.$touch()
    },

    /** 郵便番号検索 */
    async searchAddress() {
      this.isLoading = true
      await this.getAreaFromZipCd(`${this.other.YUBIN1}${this.other.YUBIN2}`)
        .then(async (item) => {
          if (item) {
            this.other.TODO_CD = ('00' + item.prefcode).slice(-2)
            this.other.TODO_MEI = this.getText(
              this.prefList,
              this.other.TODO_CD
            )
            this.other.SHIKU_MEI = item.address2
            this.other.BANCHI = item.address3
            await this.getCityList(this.other.TODO_CD)
            const city = this.getParam(
              this.cityList,
              this.other.SHIKU_MEI,
              'text'
            )
            if (city) {
              this.other.SHIKU_CD = city.value
            }
          }
        })
        .catch(() =>
          this.$nuxt.$emit('snackBarError', '住所の取得に失敗しました')
        )
      this.isLoading = false
    },

    /** 都道府県変更 */
    changePref() {
      const todoCd = this.other.TODO_CD
      this.other.TODO_MEI = null
      this.other.SHIKU_CD = ''
      this.other.SHIKU_MEI = null
      if (todoCd) {
        this.other.TODO_MEI = this.getText(this.prefList, todoCd)
        this.getCityList(this.other.TODO_CD)
      } else {
        this.cityList = []
      }
    },

    /** 市区町村変更 */
    changeCity() {
      const shikuCd = this.other.SHIKU_CD
      this.other.SHIKU_MEI = null
      if (shikuCd) {
        this.other.SHIKU_MEI = this.getText(this.cityList, shikuCd)
      }
    },

    /** 市区町村リスト取得 */
    getCityList(todoCd) {
      if (!todoCd) {
        return
      }

      this.isLoading = true
      return Store.dispatch('address/getCityList', todoCd).then(() => {
        const cityList = _.cloneDeep(Store.state.address.cityList)
        cityList.unshift({
          value: '',
          text: '未選択',
        })
        this.cityList = cityList
        this.isLoading = false
      })
    },

    /** 直接編集入力状況を再現する */
    async revival() {
      this.getCityList(this._searchCond.TODO_CD)
      await this.sleep(100)
      this.other = _.merge(this.other, this._searchCond)
      this.$emit('setData', _.cloneDeep(this.other), DATA_KBN)
    },
  },

  computed: {
    /** 定休日が必須かどうか判定する */
    isRequiredTeikyubi() {
      return this.isMeihen === 1 && this.isHikitori
    },
  },

  watch: {
    /** ローディングフラグ */
    isLoading(val) {
      this.$emit('loaded', val, DATA_KBN)
    },

    /** 直接編集入力データ */
    other: {
      handler(val) {
        this.$emit('setData', val, DATA_KBN)
      },
      deep: true,
    },

    /** 検索実行フラグ */
    async isSearch(val) {
      if (val) {
        if (this._searchCond) {
          this.revival()
        } else {
          this.other = _.cloneDeep(HIKINO_SAKI)
        }

        this.$emit('searched', DATA_KBN)
      }
    },

    /** バリデーション実行フラグ */
    async isValid(val) {
      if (val) {
        const invalid = await this.$refs.directObserver.validate()
        this.$emit('setInvalid', !invalid, DATA_KBN)
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.table-wrapper
  overflow: auto
  //height: 780px
  @include sp
    overflow: hidden
    height: auto
    max-height: 100%
.form-check-inline
  margin-right: 5px
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
</style>



// WEBPACK FOOTER //
// src/components/order/DirectEdit.vue